<template>

    <div>
        <p @click="toggleTextarea" v-show="!isTextareaShow" class="mt-2 text-blue-600 border border-blue-600 hover:bg-gray-100 focus:outline-none rounded-[5px] text-sm px-4 py-1 text-center mr-2 mb-2 w-fit hover:cursor-pointer dark:hover:bg-gray-600 dark:text-gray-400 dark:border-gray-500">
            {{ I18N.application.new_event.add_guests }}
        </p>
        <div v-show="isTextareaShow">
            <div class="mt-3 flex items-center mb-1.5">
                <label class="block text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">{{ I18N.application.new_event.guest_email }}<span v-if="CURRENT_LOCALE == 'en'">(s)</span></label>
                <span class="ml-auto text-xs text-gray-400 dark:text-gray-500">{{ guestEmails.length }}/{{ limit }}</span>
            </div>
            <div @click="focusInput" class="max-h-[47vh] flex overflow-y-auto scrollbar-style cursor-text items-baseline bg-white dark:bg-[#161b22] rounded-lg w-full min-h-[80px] px-3.5 py-2.5 border border-gray-200 dark:border-gray-700 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition-all">
              <div class="flex flex-wrap items-center">
                  <div v-for="(email, index) in guestEmails" :key="index" :class="emailBgClass(email)" class="flex mb-2 mx-0.5 px-1.5 text-sm rounded">
                    <span class="mr-0.5 break-all">{{ email }}</span>
                    <svg @click="removeGuest(index)" class="w-5 h-5 flex-shrink-0 fill-gray-700 mt-[1px] hover:cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path></svg>
                  </div>
                  <input ref="textInput" v-if="guestEmails.length < limit" type="text" v-model="newEmail" @focusout="addGuest" @paste="addGuestFromPaste" @keydown.space="addGuest" @keydown.enter="addGuest" class="flex overflow-x-hidden pt-0 text-sm min-w-[30px] flex-grow px-0 border-none bg-transparent outline-none resize-none focus:outline-0 dark:text-gray-300 focus:ring-transparent" />
              </div>
            </div>
        </div>
        
    </div>
        
    
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants";
export default {
    name: 'GuestEmails',
    mixins: [Constants],
    props: ['limit', 'guest_emails'],
    data() {
        return {
            isTextareaShow: this.guest_emails.length > 0,
            guestEmails: this.guest_emails || [],
            newEmail: '',
            invalid_email_exist: false
        };
    },
    methods: {
        toggleTextarea() {
            this.isTextareaShow = !this.isTextareaShow;
        },
        checkInvalidEmails() {
            this.invalid_email_exist = this.guestEmails.some(email => !this.isValidEmail(email));
            this.emitChange();
        },
        addGuestFromPaste(event) {
            event.preventDefault();
            this.newEmail = event.clipboardData.getData('text');
            this.addGuest();
        },
        addGuest() {
            const emails = this.newEmail.trim().split(/[\s,]+/).map(email => email.trim());
            emails.forEach(email => {
                if (email !== '') {
                    if (this.guestEmails.length < this.limit) {
                        this.guestEmails.push(email);
                    }
                }
            });
            this.newEmail = '';
            this.checkInvalidEmails();
        },
        removeGuest(index) {
            this.guestEmails.splice(index, 1);
            this.checkInvalidEmails();
        },
        isValidEmail(email) {
            // Simple email validation logic
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        focusInput() {
            this.$refs.textInput.focus();
        },
        handleDelete(event) {
            if ((event.key === 'Delete' || event.key === 'Backspace') && this.isTextareaShow && this.newEmail == '' && document.activeElement === this.$refs.textInput) {
                this.removeGuest(this.guestEmails.length - 1);
            }
        },
        emitChange() {
            this.$emit('guestEmailsChanged', this.guestEmails , this.invalid_email_exist);
        }
    },

    computed: {
        emailBgClass() {
            return (email) => {
                return this.isValidEmail(email) ? 'bg-[#e1f1fb]' : 'bg-red-200';
            };
        }

    },
    mounted() {
        this.checkInvalidEmails();
        this.emitChange();
        document.addEventListener('keydown', this.handleDelete);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleDelete);
    }
};
</script>
